export const fetchData = async (url, dispatch)=>
{
    dispatch({ type : 'LOADING' });
    const response = await fetch(url);
    const data = await response.json();
    dispatch({ type : 'DISPLAY_ITEMS', payload : data });
}